import axios from 'axios';

// Axios 인스턴스를 생성합니다.
const apiClient = axios.create({
  // .env.production 파일에 정의된 VUE_APP_API_BASE_URL 값을 기본 URL로 사용합니다.
  // 개발 환경에서는 이 값이 없으므로, vue.config.js의 프록시가 동작하도록 상대 경로를 사용하게 됩니다.
  // 개발 환경에서는 baseURL이 '/'가 되어 프록시가 /api 경로를 정상적으로 인식하고,
  // 프로덕션 환경에서는 VUE_APP_API_BASE_URL (https://astoc.co.kr:9090)이 기본 주소가 됩니다.
  baseURL: process.env.VUE_APP_API_BASE_URL || '/',
});

// 생성한 인스턴스를 다른 파일에서 import하여 사용할 수 있도록 export 합니다.
export default apiClient;